/**
 * The drift pages' provenance scope (D36, CLAUDE.md rule 4): the
 * "1,050 resources checked" part of "Assessed by Guardian at 06:12 today ·
 * 1,050 resources checked". The line itself is `briefProvenance`
 * (lib/brief-helpers.ts), shared with every other brief, which the Baseline
 * Compliance and first-run welcome briefs use as their `byline`.
 *
 * Real fields only. The count is the baseline's monitored-resource count
 * (`complianceScore.totalChecks`, blueprint §7 C10/B2), dropped when unknown.
 */

/** "1,050 resources checked", or undefined when the count is unknown (missing, not finite, or 0). */
export function resourcesCheckedScope(n: number | null | undefined): string | undefined {
  if (typeof n !== 'number' || !Number.isFinite(n) || n <= 0) return undefined
  const count = Math.round(n)
  return `${count.toLocaleString('en-US')} ${count === 1 ? 'resource' : 'resources'} checked`
}
